import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";

// LevelNoteField — ô "Ghi chú" dùng chung cho 4 form cập nhật kết quả cấp
// Khoa / Trường / Quốc gia / Quốc tế. Khác "Nhận xét": nếu bật trong cấu hình
// "Email ghi chú", BE tự gửi ghi chú này tới GV hướng dẫn sau khi lưu.
export default function LevelNoteField({ value, onChange }) {
  return (
    <Grid item xs={12}>
      <Typography variant="body2" style={{ marginBottom: 6 }}>
        Ghi chú
      </Typography>
      <TextField
        fullWidth
        multiline
        minRows={2}
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        helperText="Ghi chú sẽ được gửi email tới giảng viên hướng dẫn (nếu tính năng đang bật)."
      />
    </Grid>
  );
}
